import { useEffect, useState } from "react";
import { useGetSalesExpertInvoicePriceChart } from "../../../Production/OrderArchive/Hook";
import moment from "moment-jalaali";
import { colors } from "../components/colorList";
const useReportOfSalesExpertsContainer = () => {
  const [chartFilter, setChartFilter] = useState({ name: "mondth", enum: 1 });
  const [dataLineChart, setDataLineChart] = useState([]);
  const [salseExperts, setSalseExperts] = useState([]);
  const [total, setTotal] = useState([]);
  const [purchaseInvoiceType, setPurchaseInvoiceType] = useState("");
  const currentJalaliYear = moment().locale("en").format("jYYYY");
  const [year, setYear] = useState({ year: currentJalaliYear });
  const [month, setMonth] = useState({ month: 0 });
  const tabHandler = (type) => {
    setChartFilter(() =>
      type === "day"
        ? { name: "day", enum: 0 }
        : type === "mondth"
        ? { name: "mondth", enum: 1 }
        : { name: "year", enum: 2 }
    );
  };
  const { mutate, data } = useGetSalesExpertInvoicePriceChart();
  const bindData = (data) => {
    if (!data?.data?.data) return;
    const salseExperts = data?.data?.data.labels;
    setDataLineChart(data?.data?.data?.items);
    setSalseExperts(salseExperts);
    const createTotal = salseExperts.map((item, i) => ({
      count: data?.data?.data[i === 0 ? "total" : `total${i}`].toLocaleString(),
      color: colors[i],
      title: item,
      key: `total_1_${i}`,
    }));
    setTotal(createTotal);
  };
  useEffect(() => {
    const body = {
      chartReportTiming: chartFilter.enum,
      year: chartFilter.enum === 1 || chartFilter.enum === 0 ? year.year : 0,
      month: chartFilter.enum === 0 ? month.month : 0,
      invoiceType: purchaseInvoiceType,
    };
    mutate(body);
  }, [chartFilter, month, year, purchaseInvoiceType]);

  useEffect(() => {
    bindData(data);
  }, [data]);

  return {
    values: {
      chartFilter,
      dataLineChart,
      salseExperts,
      total,
      month,
      year,
      purchaseInvoiceType,
    },
    action: {
      tabHandler,
      setMonth,
      setYear,
      setPurchaseInvoiceType,
    },
  };
};

export default useReportOfSalesExpertsContainer;
